import React from "react";
import { CircularProgress, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffectAsync } from "../../../common/hooks/use-effect-async";
import { CameraListProvider } from "./camera-list-provider";

interface ICameraListLoaderProps {
    onLoad: (cameraList: MediaDeviceInfo[] | undefined) => void;
    onCameraAccessDenied: (errorMessage: string) => void;
}

export const CameraListLoader = (props: ICameraListLoaderProps) => {
    useEffectAsync(async () => {
        try {
            props.onLoad(await new CameraListProvider().fromNavigator());
        } catch (err) {
            props.onCameraAccessDenied(err);
        }
    }, []);

    return <div className={"scanner-content"}>
        <div className={"scanner-content__icon"}>
            <CircularProgress size={"30vh"} />
            <Typography className={"video-loader__text"}>
                {t("components.camera.loader")}
            </Typography>
        </div>
    </div>;
};
